import { Eye } from "lucide-react";
import { C } from "../../lib/api";

// After the hand (and only then): Hold'em may show one card or both; PLO shows all or nothing.
// Rendered beside the viewer's avatar (opposite the info plate) as a curved stack hugging the circle.
export const ShowCardsButtons = ({ my, hand, lastResult, plo, send, size = 105, side = "left" }) => {
  if (hand || !lastResult || !my?.in_hand || my.revealed || !my.hole?.length || my.shown?.length) return null;
  const show = (cards) => send(C.WsClientEvent.SHOW_CARDS, { hand_id: lastResult.hand_id, cards });
  const left = side === "left";
  const cls = `w-full py-1.5 text-[11px] font-display tracking-wide bg-sky-500/90 hover:bg-sky-400 text-slate-900 flex items-center gap-1.5 ${left ? "justify-end pl-3 pr-10" : "justify-start pl-10 pr-3"}`;
  const mask = `radial-gradient(circle at ${left ? "calc(100% + 22.5px)" : "-22.5px"} ${size / 2 - size * 0.22}px, transparent ${size / 2 + 8}px, #000 ${size / 2 + 9}px)`;
  const items = [["show-cards-all", "Show cards", my.hole.map((_, i) => i)]];
  return (
    <div data-testid="show-cards" className="absolute w-max flex flex-col glass rounded-2xl overflow-hidden border border-sky-300/40 shadow-lg divide-y divide-sky-900/40 rise"
      style={{ top: size * 0.22, minWidth: 130, ...(left ? { right: size - 30 } : { left: size - 30 }), WebkitMaskImage: mask, maskImage: mask }}>
      {items.map(([id, label, cards]) => (
        <button key={id} data-testid={id} onClick={() => show(cards)} className={cls}><Eye className="w-3.5 h-3.5" /> {label}</button>
      ))}
    </div>
  );
};
